import { gql } from '@apollo/client';

import { EModItemResolutionState } from '@/client/legacy-shared-modules/moderation-item/moderationType';

import { useModeration_CommentFragment } from './graphql-types/useModeration_CommentFragment';

const COMMENT_FRAGMENT = gql`
  fragment useModeration_CommentFragment on Comment {
    _id
    moderationItem {
      _id
      resolutionState
    }
    currentUserCanResolveModeratedState
    currentUserIsCommentAuthor
  }
`;

export const useModeration = (
  comment: useModeration_CommentFragment
): {
  shouldHideComment: boolean;
  shouldShowHeader: boolean;
} => {
  if (
    !comment.moderationItem?._id ||
    comment.moderationItem.resolutionState === EModItemResolutionState.APPROVED
  ) {
    return {
      shouldHideComment: false,
      shouldShowHeader: false,
    };
  }
  return comment.moderationItem.resolutionState ===
    EModItemResolutionState.PENDING
    ? comment.currentUserCanResolveModeratedState ||
      comment.currentUserIsCommentAuthor
      ? {
          shouldHideComment: false,
          shouldShowHeader: true,
        }
      : { shouldHideComment: true, shouldShowHeader: false }
    : comment.currentUserCanResolveModeratedState
    ? { shouldHideComment: false, shouldShowHeader: true }
    : { shouldHideComment: true, shouldShowHeader: false };
};
useModeration.commentFragment = COMMENT_FRAGMENT;
